import { useMemo } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { exportAsImage } from "../../utils/exportAsImage";

const COLORS = ["#3b82f6", "#ec4899"]; // blue for boys, pink for girls

export default function GenderSplit({ players, results }) {
  // Distribution of players by gender
  const genderDist = useMemo(() => {
    const groups = { Male: 0, Female: 0 };
    players.forEach((p) => {
      if (p.gender === "Male") groups.Male++;
      else if (p.gender === "Female") groups.Female++;
    });
    return Object.entries(groups).map(([gender, count]) => ({
      gender,
      count,
    }));
  }, [players]);

  // Medals distribution by gender
  const medalDist = useMemo(() => {
    const groups = { Male: 0, Female: 0 };
    results.forEach((r) => {
      if (!r.medal) return;
      const player = players.find((p) => p.id === r.playerId);
      if (!player) return;
      if (player.gender === "Male") groups.Male++;
      else if (player.gender === "Female") groups.Female++;
    });
    return Object.entries(groups).map(([gender, count]) => ({
      gender,
      count,
    }));
  }, [players, results]);

  return (
    <div className="space-y-6">
      {/* Save Button */}
      <div className="text-right">
        <button
          onClick={() =>
            exportAsImage("gender-split-section", "gender-split")
          }
          className="px-3 py-1 bg-blue-500 text-white rounded"
        >
          Save as Image
        </button>
      </div>

      <div id="gender-split-section" className="space-y-8">
        {/* Pie Chart: Player Gender Split */}
        <div className="p-4 bg-white shadow rounded-xl">
          <h1 className="mb-4">Player Gender Split</h1>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={genderDist}
                dataKey="count"
                nameKey="gender"
                outerRadius={100}
                label={(entry) => `${entry.gender} (${entry.count})`}
              >
                {genderDist.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Pie Chart: Medals by Gender */}
        <div className="p-4 bg-white shadow rounded-xl">
          <h1 className="mb-4">Medals Won by Gender</h1>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={medalDist}
                dataKey="count"
                nameKey="gender"
                outerRadius={100}
                label={(entry) => `${entry.gender} (${entry.count})`}
              >
                {medalDist.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
